export const formatPercentageDayTrade = (
  percentage: number,
  withSymbol = true,
) => {
  if (
    percentage === undefined ||
    percentage === null ||
    Number.isNaN(percentage)
  ) {
    return '';
  }

  return `${percentage.toFixed(2)}${withSymbol ? '%' : ''}`;
};

interface GetHourMinutesReturn {
  open: string;
  close: string;
  openClose: string;
}

export const formatHourMinutes = (
  timeOpen = '00:00',
  timeClose = '15:30',
): GetHourMinutesReturn => {
  const formattedOpen = timeOpen.split(':').slice(0, 2).join(':');
  const formattedClose = timeClose.split(':').slice(0, 2).join(':');

  return {
    open: formattedOpen,
    close: formattedClose,
    openClose: `${formattedOpen} - ${formattedClose}`,
  };
};

export const replaceWord = (
  words: string,
  replace: string,
  selected: string,
) => {
  if (!words) {
    return '';
  }

  return words.replace(replace, selected);
};

export const replaceWords = (
  words: string,
  replace: string[],
  selected: string[],
) => {
  if (!words) {
    return '';
  }

  let newWords = words;

  replace.forEach((item, index) => {
    newWords = replaceWord(newWords, item, selected[index]);
  });

  return newWords;
};
